export async function fetchLikes() {
  try {
    const res = await fetch('/api/likes');
    if (!res.ok) return {};
    return await res.json();
  } catch {
    return {};
  }
}

export async function likeProject(projectId) {
  const res = await fetch('/api/likes', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ projectId }),
  });

  if (!res.ok) throw new Error('Failed to like project');

  return res.json();
}
